// =============================================
// SERENITY FELTING — THEME JS
// =============================================

document.addEventListener('DOMContentLoaded', function () {

  // ---- CART DRAWER ----
  var cartToggle  = document.getElementById('cart-toggle');
  var cartClose   = document.getElementById('cart-close');
  var cartOverlay = document.getElementById('cart-overlay');
  var cartDrawer  = document.getElementById('cart-drawer');

  function openCart()  {
    cartDrawer.classList.add('is-open');
    cartOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    cartDrawer.classList.remove('is-open');
    cartOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  if (cartToggle)  cartToggle.addEventListener('click', openCart);
  if (cartClose)   cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  // ---- MOBILE NAV ----
  var navToggle = document.getElementById('nav-toggle');
  var siteNav   = document.getElementById('site-nav');
  if (navToggle && siteNav) {
    navToggle.addEventListener('click', function () {
      var open = siteNav.classList.toggle('is-open');
      navToggle.setAttribute('aria-expanded', open);
    });
  }

  // ---- CART COUNT ----
  updateCartCount();

  // ---- PRODUCT CARD QUICK-ADD ----
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-product-id]');
    if (!btn) return;
    e.preventDefault();
    var variantId = parseInt(btn.dataset.productId);
    addToCart(variantId, 1, btn);
  });

});

// ---- ADD TO CART (AJAX) ----
function addToCart(variantId, quantity, btn) {
  if (btn) { btn.textContent = '...'; btn.disabled = true; }
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
  })
  .then(function (r) { return r.json(); })
  .then(function () {
    if (btn) { btn.textContent = '✓'; setTimeout(function () { btn.textContent = '+ Add'; btn.disabled = false; }, 1500); }
    updateCartCount();
    refreshCartDrawer();
  })
  .catch(function () {
    if (btn) { btn.textContent = '+ Add'; btn.disabled = false; }
  });
}

// ---- UPDATE CART COUNT ----
function updateCartCount() {
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var el = document.getElementById('cart-count');
      if (el) el.textContent = cart.item_count;
    });
}

// ---- REFRESH CART DRAWER HTML ----
function refreshCartDrawer() {
  fetch('/cart?sections=cart-items')
    .then(function (r) { return r.json(); })
    .catch(function () {});
  // For simplicity, reload cart data via cart.js and rebuild
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var body = document.getElementById('cart-drawer-body');
      if (!body) return;
      if (cart.item_count === 0) {
        body.innerHTML = '<div class="cart-empty"><span class="cart-empty__icon">🦙</span><p class="cart-empty__text">Your cart is empty.<br>Your alpacas are waiting.</p></div>';
        var foot = document.querySelector('.cart-drawer__footer');
        if (foot) foot.style.display = 'none';
      } else {
        var items = cart.items.map(function (item) {
          return '<div class="cart-item">' +
            '<img class="cart-item__img" src="' + item.image + '" alt="' + item.title + '" width="72" height="72">' +
            '<div class="cart-item__info">' +
              '<div class="cart-item__title">' + item.product_title + '</div>' +
              (item.variant_title && item.variant_title !== 'Default Title' ? '<div class="cart-item__variant">' + item.variant_title + '</div>' : '') +
              '<div class="cart-item__variant">Qty: ' + item.quantity + '</div>' +
              '<div class="cart-item__footer">' +
                '<span class="cart-item__price">$' + (item.final_line_price / 100).toFixed(2) + '</span>' +
                '<button class="cart-item__remove" onclick="removeFromCart(\'' + item.key + '\')">Remove</button>' +
              '</div>' +
            '</div>' +
          '</div>';
        }).join('');
        body.innerHTML = items;

        var foot = document.querySelector('.cart-drawer__footer');
        if (foot) {
          foot.style.display = 'block';
          var sub  = foot.querySelector('[id="cart-subtotal"]') || foot.querySelectorAll('span')[1];
          var tot  = foot.querySelectorAll('span');
          foot.innerHTML =
            '<div class="cart-subtotal"><span>Subtotal</span><span>$' + (cart.total_price / 100).toFixed(2) + '</span></div>' +
            '<div class="cart-subtotal"><span>Shipping</span><span>Calculated at checkout</span></div>' +
            '<div class="cart-total"><span>Total</span><span>$' + (cart.total_price / 100).toFixed(2) + '</span></div>' +
            '<a href="/checkout" class="cart-checkout-btn">Proceed to Checkout</a>';
        }
      }
    });
}

// ---- REMOVE FROM CART ----
function removeFromCart(key) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: 0 })
  })
  .then(function () {
    updateCartCount();
    refreshCartDrawer();
  });
}
